import { hasValue } from "@/Utils/Objects";
import type { Locale } from "../Model/Domain";

import useI18nStore from "../Store";

import { getAllLocales } from "@/Services/TherapyApi/Translations";
import LocaleTransformer from "@/Modules/Transformers/Locale";
import localeCacheService from "../Services/LocaleCacheService";

async function FetchLocalesActionHandler(): Promise<Locale[]> {
  const I18nStore = useI18nStore();

  const localesResp = await getAllLocales();

  if (!hasValue(localesResp) || localesResp.length === 0) {
    return [];
  }

  localesResp.forEach((locale) => {
    const domainLocale = LocaleTransformer.toDomain(locale);

    I18nStore.locales.set(domainLocale.locale, domainLocale);
    localeCacheService.set(domainLocale);
  });

  return localesResp.map((locale) => I18nStore.locales.get(locale.locale)!);
}

export default FetchLocalesActionHandler;
